import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { CustomInputForm } from './CustomInputForm';
import { isEmpty, nonNull } from '../../util/CommonUtils';
export var NumericField = function (_a) {
    var _b = _a.noFormatEmptyClbck, noFormatEmptyClbck = _b === void 0 ? false : _b, _c = _a.id, id = _c === void 0 ? 'numeric-input' : _c, _d = _a.variant, variant = _d === void 0 ? 'outlined' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.label, label = _f === void 0 ? 'Número' : _f, _g = _a.required, required = _g === void 0 ? false : _g, MascComponent = _a.MascComponent, placeholder = _a.placeholder, helperText = _a.helperText, _h = _a.before, before = _h === void 0 ? 8 : _h, _j = _a.after, after = _j === void 0 ? 0 : _j, onChange = _a.onChange, value = _a.value, name = _a.name;
    //region Constants
    var _k = useState(''), inputValue = _k[0], setInputValue = _k[1];
    //endregion
    //region Hooks
    useEffect(function () {
        var _a, _b;
        if (nonNull(value) && !isEmpty("".concat(value !== null && value !== void 0 ? value : ''))) {
            var formatted = (_b = ((_a = value === null || value === void 0 ? void 0 : value.toFixed(after)) === null || _a === void 0 ? void 0 : _a.replace('.', ','))) !== null && _b !== void 0 ? _b : '';
            setInputValue(formatted);
        }
        else {
            setInputValue('');
        }
    }, [value, after]);
    var regex = useMemo(function () {
        return new RegExp("^\\d{0,".concat(before, "}(,\\d{0,").concat(after, "})?$"));
    }, [before, after]);
    //endregion
    //region Handles
    var handleChange = function (event) {
        var newValue = event.target.value;
        newValue = newValue.replace(/[^\d,]/g, '');
        if ((newValue.match(/,/g) || []).length > 1)
            return;
        if (!newValue.includes(',') && newValue.length > before) {
            newValue =
                newValue.slice(0, before) + ',' + newValue.slice(before);
        }
        if (regex.test(newValue)) {
            setInputValue(newValue);
        }
    };
    var handleBlur = function () {
        var _a;
        if (!inputValue && noFormatEmptyClbck) {
            onChange === null || onChange === void 0 ? void 0 : onChange(null);
            return;
        }
        var numericValue = parseFloat(inputValue.replace(',', '.'));
        if (isNaN(numericValue)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(null);
            setInputValue('');
            return;
        }
        var formatted = (_a = numericValue === null || numericValue === void 0 ? void 0 : numericValue.toFixed(after)) === null || _a === void 0 ? void 0 : _a.replace('.', ',');
        setInputValue(formatted);
        onChange === null || onChange === void 0 ? void 0 : onChange(Number(numericValue === null || numericValue === void 0 ? void 0 : numericValue.toFixed(after)));
    };
    var handleMask = useMemo(function () {
        return MascComponent ? { inputComponent: MascComponent } : undefined;
    }, [MascComponent]);
    //endregion
    return (_jsx(CustomInputForm, { inputProps: { inputMode: 'decimal', pattern: '[0-9,]*' }, placeholder: placeholder, onChange: handleChange, helperText: helperText, InputProps: handleMask, error: !!helperText, required: required, disabled: disabled, onBlur: handleBlur, value: inputValue, variant: variant, label: label, name: name, fullWidth: true, id: id }));
};
